













































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import PandaMobileTable from "@/components/mobile-custom/panda-table.vue";

import PandaMobileTWFContainer from "@/components/mobile-custom/panda-table-with-filter-container.vue";

import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
// import { screen } from "@/common/screen/screen";
import IdolTechnicalServiceShopFeeListAPI from "@/common/api/financeManage/idolTechnicalServiceShopFeeList";
import { CommonApi } from "@/common/api/common";
import { excuteDownloadExport2Excel } from "@/common/xlsx";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { utils } from "xlsx";

import gallery from "@/components/gallery.vue";

import { shareConfirmOptions } from "@/common/config";

export const pageApiList = getPageAPIs(IdolTechnicalServiceShopFeeListAPI);

const transformGender = ["", "女", "男"];

// 审核状态 2:审核中3:审核通过5:审核未通过

const defaultForm: any = {
  name: "",
  // phone: "",
  // status: 2, // 状态  2:审核中3:审核通过5:审核未通过
};

@Component({
  components: {
    gallery,
    PandaMobileTable,
    PandaMobileTWFContainer,
  },
  filters: {},
})
export default class IdolTechnicalServiceShopFee extends Vue {
  /** 移动端相关属性 方法 */
  private allMobileChooseFields: any[] = [
    {
      label: "店铺",
      field: "name",
    },
    {
      label: "总抽成",
      field: "total_commission",
    },
    {
      label: "商品抽成",
      field: "commodity_commission",
    },
    {
      label: "台球抽成",
      field: "billiard_commission",
    },
    {
      label: "棋牌抽成",
      field: "chess_commission",
    },
    {
      label: "KTV抽成",
      field: "ktv_commission",
    },
    {
      label: "单店卡充值抽成",
      field: "shop_member_commission",
    },
    {
      label: "操作",
      field: "table-option",
    },
  ];
  /** end 移动端相关属性 方法 */

  private form: any = {
    // // type:  0, // 问题类型
    // user_id: "", // 用户ID
    // nickname: "", // 助教昵称
    // is_status: 1, // 状态
    // time: [], // 时段选择
  };
  private deepLoopUtil: any;

  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    };
  }
  private idolTechnicalServiceShopFeeListApi: any =
    new IdolTechnicalServiceShopFeeListAPI();
  // private created(): void {
  //   // this.getProblemTypes();
  //   this.search();
  // }

  private activated(): void {
    this.search();
  }

  private getTable(): void {
    this.idolTechnicalServiceShopFeeListApi.getList(
      {
        ...this.getTechnicalServiceFeeParams(),
      },
      (res: any) => {
        this.tableData = res.data.list;
        this.tablePage.pageNo = res.data.page || this.tablePage.pageNo;
        this.tablePage.pageSize = res.data.prepage || this.tablePage.pageSize;
        this.tablePage.totalCount = res.data.count;
      }
    );
  }

  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }
  // private problemList: any[] = [
  //   ...problemList
  // ];

  // // 审核状态 1待审核 2审核通过 3驳回
  // private statusList: any[] = [
  //   {
  //     label: "审核中",
  //     value: 2,
  //   },
  //   {
  //     label: "审核通过",
  //     value: 3,
  //   },
  //   {
  //     label: "审核未通过",
  //     value: 5,
  //   },
  // ];

  // private systemTypaName: any[] = ["未知", "安卓", "IOS", "小程序"];

  // // 审核拒绝弹框
  // private dialogFormRejectVisible: boolean = false

  // private curRejectAuditItem: any

  // private sumbitRejectAuditLoading: boolean = false

  // private rejectForms: any = {
  //   reject_reason: ''
  // }

  // private handleSumbitRejectAudit() {
  //   const rejectForms = this.rejectForms

  //   const {
  //     reject_reason
  //   } = rejectForms || {}

  //   if (!reject_reason) {
  //     this.$message.error("请输入拒绝原因")
  //     return
  //   }

  //   const curRejectAuditItem = this.curRejectAuditItem

  //   this.sumbitRejectAuditLoading = true

  //   this.idolTechnicalServiceShopFeeListApi.updateTechnicalServiceFeeStatus(
  //     {
  //       id: curRejectAuditItem.id,
  //       reject_reason,
  //       mode: 'disagree',
  //       // status: 1
  //     },
  //     () => {
  //       this.sumbitRejectAuditLoading = false

  //       this.dialogFormRejectVisible = false

  //       this.getTable();
  //     },
  //     () => {
  //       this.sumbitRejectAuditLoading = false
  //     }
  //   );
  // }

  // // 更新状态
  // private handleUpdateTechnicalServiceFeeStatus(row: any, mode: string) {
  //   const modeMsgs: any = {
  //     agree: "通过",
  //     disagree: "不通过",
  //   };

  //   // const disArgeeConfirmOptions = {
  //   //   showInput: true,
  //     // inputPlaceholder: '请输入拒绝原因',
  //     // inputType: 'textarea'
  //   // }

  //   const confirmOptions = {
  //     ...shareConfirmOptions,

  //   }

  //   if (mode == 'disagree') {
  //     this.curRejectAuditItem = row

  //     this.rejectForms = {
  //       reject_reason: ''
  //     }

  //     this.dialogFormRejectVisible = true

  //     return
  //   }
  //   this.$confirm(`确定${modeMsgs[mode]}该项申请?`, "", confirmOptions).then(() => {
  //     const tableData = this.tableData;

  //     const existRowIndex = tableData.indexOf(row);

  //     if (existRowIndex > -1) {
  //       row.__updateFeedbackStatusLoading = true;

  //       tableData.splice(existRowIndex, 1, row);

  //       this.idolTechnicalServiceShopFeeListApi.updateTechnicalServiceFeeStatus(
  //         {
  //           id: row.id,
  //           mode,
  //           // status: 1
  //         },
  //         () => {
  //           row.__updateFeedbackStatusLoading = false;

  //           tableData.splice(existRowIndex, 1, row);

  //           this.getTable();
  //         },
  //         () => {
  //           row.__updateFeedbackStatusLoading = false;

  //           tableData.splice(existRowIndex, 1, row);
  //         }
  //       );
  //     }
  //   });
  // }

  private get chooseDate() {
    const route = this.$route;

    const { query } = route || {};

    return query ? query.date || "" : "";
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private images: any = [];

  private getTechnicalServiceFeeParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const {
      name,
      // finish_time, // 完成时间
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};

    if (this.chooseDate) {
      outerParams.date = this.chooseDate;
    }

    if (name) {
      outerParams.name = name;
    }

    // if (mode == "exportExcel") {
    //   delete outerParams.date

    //   outerParams.start_date = this.chooseDate

    //   outerParams.end_date = this.chooseDate
    // }

    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   outerParams.start_date = startTime;

    //   outerParams.end_date = endTime;
    // }

    if (mode == "exportExcel" && !outerParams.date) {
      this.$message.error("暂无时间信息，请稍后重试");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      // outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  private handleWakeShopIncomeDetail(shopItem: any) {
    console.log(shopItem, "shopItem");

    this.$router.push({
      path: "/idolTechnicalServiceShopIncomeList",
      query: {
        shop_id: shopItem.shop_id,
      },
    });
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 字段名 文案对应关系
  private technicalServiceShopFeeExcelList2ch: any = {
    name: "店铺",
    total_commission: "总抽成",
    commodity_commission: "商品抽成",
    billiard_commission: "台球抽成",
    chess_commission: "棋牌抽成",
    ktv_commission: "KTV抽成",
    shop_member_commission: "单店卡充值抽成",
  };
  // 商户Excel 表头的先后顺序
  private technicalServiceShopFeeExcelSortList: string[] = [
    "name",
    "total_commission",
    "commodity_commission",
    "billiard_commission",
    "chess_commission",
    "ktv_commission",
    "shop_member_commission",
  ];

  // // 点击导出excel 表格
  private handleExportExcelTechnicalServiceShopFeeList() {
    const params = this.getTechnicalServiceFeeParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.idolTechnicalServiceShopFeeListApi.exportTechnicalServiceFeeList(
      params,
      (res: any) => {
        const { date } = params || {};

        const filename = `大明星技术服务费店铺详情列表 ${date}到${date}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const { status } = item || {};
              const newItem = {
                ...(item || {}),
                // __status: withdrawAccountAudit2Text[status]
              };

              for (let key in item) {
                if (typeof item[key] == "number") {
                  newItem[key] = item[key].toString();
                }
              }

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const technicalServiceShopFeeExcelSortList =
            this.technicalServiceShopFeeExcelSortList;

          const technicalServiceShopFeeExcelList2ch =
            this.technicalServiceShopFeeExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            technicalServiceShopFeeExcelSortList,
            technicalServiceShopFeeExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */
}
